<template>
  <section class="app-main">
    <div class="top-bar">
      <div style="display:flex;">
      <el-input
        placeholder="请输入批次号（必填）"
        v-model="batch"
        @change="search"
        style="width: 200px;margin-right:30px;"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-input
        placeholder="输入条形码/商品名称查询"
        v-model="searchVal"
        @change="search"
        style="width: 240px"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      </div>
    </div>
    <!-- 商品列表 -->
    <el-card shadow="hover">
      <el-table
        :data="tableData"
        @selection-change="tableChange"
        height="600"
        style="width: 100%"
      >
        <el-table-column
          label="商品图片"
          align="center"
        >
         <template slot-scope="scope">
                <m-img v-if="scope.row.goods_sku_pic_url" :src="scope.row.goods_sku_pic_url" />
          </template>
        </el-table-column>
        <el-table-column
          prop="batch"
          label="商品批次"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goods_name"
          label="商品名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="barcode"
          label="条形码"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="goods_number"
          label="商品数量"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="reloadData"
        layout="prev, pager, next, jumper"
        style="padding: 15px"
        :total="total"
        :page-size="size"
      ></el-pagination>
    </el-card>

    <!-- 展开商品详情弹框 -->
    <el-dialog
    v-if="false"
      title="订单详情"
      :visible.sync="detail_modal"
      :close-on-click-modal="false"
      center
      width="1200px"
    >
      <el-card class="m-bottom-4">
        <el-row class="m-bottom-2">
          <el-col :span="12" class="row-height"
            >订单号码：{{ detail.title }}</el-col
          >
          <el-col :span="12" class="row-height"
            >下单时间：{{ detail.updated_at }}</el-col
          >
        </el-row>
        <el-row class="m-bottom-2">
          <el-col :span="12" class="row-height"
            >下单账号：{{
              detail.phone != "" ? detail.phone : (detail.email!=''?detail.email:(detail.order_logistics.tel!=''?detail.order_logistics.tel : detail.order_logistics.email))
            }}</el-col
          >
          <el-col :span="12" v-if="detail.order_logistics" class="row-height"
            >联 系 人：{{ detail.order_logistics.surname + '-'+ detail.order_logistics.name }}</el-col
          >
        </el-row>
        <el-row class="m-bottom-2" v-if="detail.order_logistics">
          <el-col :span="12" class="row-height"
            >联系电话：{{ detail.order_logistics.tel }}</el-col
          >
          <el-col :span="12" class="row-height"
            >联系邮箱：{{ detail.order_logistics.email }}</el-col
          >
        </el-row>
        <el-row class="row-height">
          <el-col :span="12" v-if="detail.delivery_method == 1">
            取 件 码 ：{{ detail.pick_up_code }}
          </el-col>
          <el-col :span="12" v-if="detail.delivery_method == 0" style="padding-right:36px;">
            地址详情：{{
              detail.order_logistics.address +
              ", " +
              (detail.order_logistics.city_arr ? detail.order_logistics.city_arr.ename : detail.order_logistics.city_name) +
              ", " +
              detail.order_logistics.province_arr.abbreviation +
              ", " +
              detail.order_logistics.country_arr.ename +
              ", " +
              detail.order_logistics.zipcode
            }}
          </el-col>
          <el-col :span="12" class="row-height"
            >收货方式：{{ detail.delivery_method_title }}</el-col
          >
        </el-row>
      </el-card>

      <el-card class="m-bottom-4" v-if="detail.title">
        <p
          style="
            line-height: 40px;
            color: #666;
            font-size: 16px;
            border-bottom: 1px solid #e0e0e0;
            text-align: center;
          "
        >
          {{ detail.shops_title }}
        </p>
        <el-table :data="detail.order_goods" max-height="300">
          <el-table-column label="商品图片" align="center" width="100">
            <template slot-scope="scope">
              <m-img
                v-if="scope.row.goods_sku_pic_url"
                :src="scope.row.goods_sku_pic_url"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="商品名称"
            show-overflow-tooltip
            align="center"
            width="200"
          >
            <template slot-scope="scope">{{ scope.row.goods_name }}</template>
          </el-table-column>
          <el-table-column
            label="商品规格"
            align="center"
            width="140"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ scope.row.sku_name }}</template>
          </el-table-column>
          <el-table-column label="条形码" align="center" width="160">
            <template slot-scope="scope">{{ scope.row.barcode }}</template>
          </el-table-column>
          <el-table-column label="购买数量" align="center" width="80">
            <template slot-scope="scope">{{ scope.row.goods_number }}</template>
          </el-table-column>
          <el-table-column label="购买价格" align="center">
            <template slot-scope="scope">{{ scope.row.goods_price }}</template>
          </el-table-column>
          <el-table-column label="PST" align="center">
            <template slot-scope="scope">{{ scope.row.pst_amount }}</template>
          </el-table-column>
          <el-table-column label="GST" align="center">
            <template slot-scope="scope">{{ scope.row.gst_amount }}</template>
          </el-table-column>
          <el-table-column label="HST" align="center">
            <template slot-scope="scope">{{ scope.row.hst_amount }}</template>
          </el-table-column>
          <el-table-column label="QST" align="center">
            <template slot-scope="scope">{{ scope.row.qst_amount }}</template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card v-if="detail.title">
        <el-row class="row-height">
          <span class="row-span">商品价格：{{ detail.goods_amount }} </span>
          <span class="row-span">钱包抵扣：{{ detail.goods_wallet_fee }} </span>
          <span class="row-span">优惠金额：{{ detail.goods_discount_fee }} </span>
          <span class="row-span" v-if="detail.pst_amount != '0.00'"
            >PST：{{ detail.pst_amount }}
          </span>
          <span class="row-span" v-if="detail.gst_amount != '0.00'"
            >GST：{{ detail.gst_amount }}
          </span>
          <span class="row-span" v-if="detail.hst_amount != '0.00'"
            >HST：{{ detail.hst_amount }}
          </span>
          <span class="row-span" v-if="detail.qst_amount != '0.00'"
            >QST：{{ detail.qst_amount }}
          </span>
          <span class="row-span">运费：{{ detail.shipping_fee }}</span>
        </el-row>
        <p
          style="
            text-align: right;
            font-size: 16px;
            font-weight: bold;
            padding: 0 30px 10px 0;
          "
        >
          支付总价：{{ detail.order_total_amount }}
        </p>
      </el-card>
    </el-dialog>
  </section>
</template>



<script>
import { presaleGoodsList, presellGoodsListDetail } from "@/api/order.js";
import MImg from "./../../../components/Image";
export default {
  components: { MImg },
  data() {
    return {
      searchVal: "",
      tableData: [],
      ids: [],
      total: 0,
      page: 1,
      size: 10,
      disabled: false,
      detail_modal: false,
      detail: {},
      batch: ""
    };
  },
  methods: {
    search() {
      this.page = 1;
      this.getData();
    },
    // 日期查询搜索
    handleDate() {
      this.page = 1;
      this.getData();
    },
    getData() {
      this.tableData = [];
      let params = {
        batch: this.batch
      };
      if (this.searchVal != "") {
        params.goods_info = this.searchVal;
      }
    //   if (this.coupon.periodType != "") {
    //     params.status_search = this.coupon.periodType;
    //   }
      presaleGoodsList(params).then((res) => {
        if (res) {
          this.tableData = res.data;
        }
      });
    },
    reloadData(page) {
      this.page = page;
      this.getData();
    },

    // 表格选中变化
    tableChange(rows) {
      this.ids = [];
      rows.forEach((e) => {
        this.ids.push(e.id);
      });
    },
    // 获取订单详情
    showDetail(row) {
      presellGoodsListDetail(row.id).then((res) => {
        if (res) {
          this.detail = res.data;
          this.detail_modal = true;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
section {
  .row-height {
    height: 40px;
    line-height: 40px;
    .row-span + .row-span {
      margin-left: 15px;
    }
  }
}
</style>

